import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { crewService } from '@services/crew';
import { CREWS_BY_USER_QUERY_KEY } from './useCrews';
import { getErrorMessage } from '@utils/errorMessage';
import { useTranslation } from '@hooks/useTranslation';

export const useCreateCrew = () => {
  const tActionMessages = useTranslation('actionMessages');
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['crew', 'create'],
    mutationFn: async (name: string) => {
      if (!name || !name.trim()) throw new Error('Name is required');
      return await crewService.createCrew(name.trim());
    },
    onSuccess: () => {
      toast.success(tActionMessages.crewCreatedSuccessfully);
      queryClient.invalidateQueries({ queryKey: CREWS_BY_USER_QUERY_KEY });
    },
    onError: (error: any) => {
      toast.error(getErrorMessage(error, tActionMessages.requestError));
    },
  });
};

export default useCreateCrew;
